import { FormEvent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useChatgelesenMutation, useChatvonallengelesenMutation, useGetAuftraegeWithMessagesMutation } from '../../api/AuftragMessagesAPI';
import AuftragMessageComponent from '../../component/chat/AuftragMessageComponent/AuftragMessageComponent';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import ScrollToTopBadge from '../../component/ScrollToTop';
import { IAuftragMessageListe, ProfileInfo } from '../../types/Types';
import { formatToEuroDateTime } from '../../util/DateUtils';
import LandingpageHeader from '../header/LandingpageHeader';
import { useWhoamiMutation } from '../../api/LoginAPI';

/**
 * @author noone
 */
type ThisProps = {
  //originalListe: IAuftragAgAnsicht[];
  //statusChanged: () => void;
}

export default function ChatListe(props: ThisProps) {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const [whoamiAPI] = useWhoamiMutation();
  const [getChatListeAPI] = useGetAuftraegeWithMessagesMutation();
  const [chatGelesenAPI] = useChatgelesenMutation();
  const [chatVonAllenGelesenAPI] = useChatvonallengelesenMutation();

  const [whoami, setWhoami] = useState<ProfileInfo>();
  const [anzeige, setAnzeige] = useState<String>("");
  const [chatDetail, setChatDetail] = useState<IAuftragMessageListe>();
  const [liste, setListe] = useState<IAuftragMessageListe[]>([]);
  const [intern, setIntern] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const handleAlleGelesen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    chatGelesenAPI(chatDetail!!.uid_auftrag).unwrap()
      .then(() => {
        setListe((prevListe) => prevListe.map((chat) => {
          if (chat.uid_auftrag === chatDetail!!.uid_auftrag) {
            return { ...chat, anzahl_nicht_gelesen: 0 };
          }
          return chat;
        }));
        setRefreshTrigger((prev) => prev + 1);
      })
      .catch((error) => console.log(error));
  }

  const handleVonAllenAlleGelesen = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    chatVonAllenGelesenAPI(chatDetail!!.uid_auftrag).unwrap()
      .then(() => {
        setListe((prevListe) => prevListe.map((chat) => {
          if (chat.uid_auftrag === chatDetail!!.uid_auftrag) {
            return { ...chat, anzahl_nicht_gelesen: 0 };
          }
          return chat;
        }));
        setRefreshTrigger((prev) => prev + 1);
      })
      .catch((error) => console.log(error));
  }

  useEffect(() => {
    whoamiAPI().unwrap()
      .then(data => setWhoami(data))
      .catch((e) => console.log(e));
  }, [whoamiAPI]);

  useEffect(() => {
    if (
      whoami?.rollen.includes("admin")
      || whoami?.rollen.includes("office")
      || whoami?.rollen.includes("aussendienst")
    ) {
      setIntern(true);
    }
  }, [whoami]);

  useEffect(() => {
    window.scrollTo(0, 0);

    setIsLoading(true);
    getChatListeAPI().unwrap()
      .then((data) => {
        const filtered = data.filter((e) => e.anzahl_gesamt > 0);
        const sorted = [...filtered].sort((a, b) => {
          const ta = a.lastMessageDateTime ? new Date(a.lastMessageDateTime).getTime() : 0;
          const tb = b.lastMessageDateTime ? new Date(b.lastMessageDateTime).getTime() : 0;
          return tb - ta; // neueste zuerst
        });
        setListe(sorted);
      })
      .catch((error) => console.error("Fehler beim Laden der Chat Liste:", error))
      .finally(() => setIsLoading(false))
      ;
  }, []);

  const scrollToBottom = () => {
    document.getElementById('newMessageForm')?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <>
      {anzeige === "" &&
        <div>

          <LandingpageHeader />

          <div className="container">

            <button
              onClick={() => {
                navigate("/", {
                  relative: "path"
                });
              }}

              style={{ marginBottom: "20px" }}
              className=' btn btn-outline-primary'
            ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
            </button>

            <h3>Chat Liste</h3>

            {liste.map((chat) =>
              <>
                <div key={chat.uid_auftrag} className="card shadow-sm mb-4">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start">

                      <div>
                        <h5 className="card-title mb-1">Kunde: {chat.auftragDto.vorname_endkunde} {chat.auftragDto.name_endkunde} / AG: {chat.auftragDto.auftraggeber.name}</h5>
                        {chat.anzahl_nicht_gelesen > 0 &&
                          <span className="badge bg-success rounded-pill" style={{ color: "white" }}>
                            Neue Nachrichten&nbsp;•&nbsp;{chat.anzahl_nicht_gelesen}
                          </span>
                        }
                      </div>

                      <div className="d-flex gap-2">
                        <a href="#" className="btn btn-primary" onClick={() => { setAnzeige("detail"); setChatDetail(chat); }}><i className="bi bi-chat"></i> zum Chat</a>
                        {!intern && <>
                          <a href="#" className="btn btn-outline-secondary" onClick={() => navigate("/eigeneauftraege/detail/" + chat.auftragDto.uid)}><i className="bi bi-file-earmark-post"></i> zum Auftrag</a>
                        </>}
                        {intern && <>
                          <button className="btn" onClick={(event: FormEvent) => { event.stopPropagation(); window.open("./.auftragdetails?uid=" + chat.auftragDto.uid + "&backbuttonClose=true", "_blank"); }} ><i className='bi bi-pencil-fill'></i></button>
                        </>}
                      </div>
                    </div>

                    <hr className="my-4" />

                    <p className="mb-1"><strong>Gesamt:</strong> {chat.anzahl_gesamt}</p>
                    <p className="mb-0"><strong>Letzte Nachricht:</strong> {formatToEuroDateTime(chat.lastMessageDateTime)}</p>
                  </div>
                </div>

              </>
            )}

            <ScrollToTopBadge />

          </div>

          <LoadingModal show={isLoading} />

        </div >
      }
      {anzeige === "detail" &&
        <>
          <div>

            <LandingpageHeader />

            <div className="container">

              <div style={{ position: "sticky", top: "0px", zIndex: 100, backgroundColor: "white", padding: "10px", borderRadius: "5px" }}>

                <button
                  onClick={() => {
                    setAnzeige("");
                  }}

                  style={{ marginBottom: "20px" }}
                  className=' btn btn-outline-primary'
                ><i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
                </button>

                <button onClick={handleAlleGelesen}
                  style={{ marginBottom: "20px" }}
                  className=' btn btn-outline-success'
                ><i className="bi bi-eye"></i> alle gelesen
                </button>

                {intern &&
                  <>
                    <button onClick={handleVonAllenAlleGelesen}
                      style={{ marginBottom: "20px" }}
                      className=' btn btn-outline-success'
                    ><i className="bi bi-eye"></i> Haben auch alle anderen Mitarbeiter gelesen
                    </button>

                    <button style={{ marginBottom: "20px" }} className="btn btn-outline-secondary" onClick={(event: FormEvent) => { event.stopPropagation(); window.open("./.auftragdetails?uid=" + chatDetail?.uid_auftrag + "&backbuttonClose=true", "_blank"); }} ><i className='bi bi-pencil-fill'></i></button>

                  </>}

                <button onClick={() => scrollToBottom()}
                  style={{ marginBottom: "20px" }}
                  className=' btn btn-outline-info'
                >
                  <i className="bi bi-box-arrow-in-down "></i> ans Ende springen
                </button>

                {!intern && <>
                  <button style={{ marginBottom: "20px" }} className="btn btn-outline-secondary" onClick={() => navigate("/eigeneauftraege/detail/" + chatDetail?.uid_auftrag)}><i className="bi bi-file-earmark-post"></i> zum Auftrag</button>
                </>}

              </div>

              {chatDetail &&
                <AuftragMessageComponent auftragUid={chatDetail?.uid_auftrag ?? ''} refreshTrigger={refreshTrigger} />
              }

              <ScrollToTopBadge />

            </div>

          </div >
        </>
      }
    </>
  );

}
